export const tabKeys = {
    BMAT: 'BMAT',
    TUNESAT: 'TuneSat',
};
